import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { Proyecto, ProyectosAdapter } from '../../../../../infraestructure/persistence/rest/ProyectosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboProyectos from './combo';


export const ComboProyectosContainer = (props: any) => {
  
  const {fechaHasta} = props;
  const api = new ProyectosAdapter();
  const { exceptionError, resultError } = useNotifications();
  let [proyectos, setProyectos] = useState<any>(undefined)
  let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
	let result: any;
  
  useEffect(()=>{
    if(!props.disabled){
      if(props.idSociedad){
        getProyectosSociedad();
        setSelectedOptions([...[]])
      }else{
        props.dependency ? setProyectos([...[]]) : getProyectos()
      }
    }
  },[props.idSociedad])

  useEffect(()=>{setSelectedOptions(props.selectedOptions)},[props.selectedOptions])

  const getProyectosSociedad = async () => {
		try {
      result = await api.ListarProyectosSociedad(props.idSociedad);
      if(result.data && result.data!=="")
			{
        setProyectos([ ...result.data ]);
      }else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

	const getProyectos = async () => {
		try {
      result = await api.ListarProyectos();
      if(result.data && result.data!=="")
			{
        setProyectos([ ...result.data ]);
      }else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  const getProyectosFilter = useMemo(() =>{
    const proyectosFilter = proyectos!==undefined ? 
    (fechaHasta!==undefined ? proyectos.filter((s:Proyecto)=> s.fechaBaja === null || moment(fechaHasta).isBefore(s.fechaBaja)) : proyectos) : []
    return proyectosFilter;
  },[proyectos,fechaHasta])


  return <ComboProyectos {...{...props,...{selectedOptions:selectedOptions}}} options={getProyectosFilter}/>
};

export default ComboProyectosContainer;